<template>
  <div>
    <b-card ref="card" no-body>
      <div class="pt-5 px-2">
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="5">
                <b-form-input v-model="keyword" class="d-inline-block round" placeholder="Type here..." />
              </b-col>
              <b-col cols="7">
                <b-button variant="primary" @click="renderView++;newBooking();" class="btn-sm float-right mb-1">
                  <feather-icon icon="PlusIcon" /> New Booking Note
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="py-2">
          <b-col cols="12">
            <vue-good-table ref="my-table" :columns="columns" :row-style-class="'clickable'" :rows="items"
              :pagination-options="{
                enabled: true,
                dropdownAllowAll: false,
              }" mode="remote" :sort-options="{ enabled: false }" @on-row-dblclick="onRowDoubleClick"
              @on-page-change="onPageChange" @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <div class="test-container" @contextmenu.prevent="onClickRightOpenMenu($event, props.row)">
                  <!-- Column: Action -->
                  <span v-if="props.column.field === 'action'">
                    <span class="d-flex" style="gap: 10px">
                      <b-button variant="primary" v-if="props.row.status == 0 && moment(props.row.etd, 'DD/MM/YY') > moment() || (props.row.status == 0 && (props.row.etd == 'null' || !props.row.etd) ? true : false)
                      
                      " size="sm" class="btn" v-b-tooltip.hover.top="'Edit Booking Note'"
                        @click="onRowEditClick(props)">
                        <feather-icon icon="EditIcon" />
                      </b-button>
                      <b-button variant="primary" size="sm" v-if="
                        props.row.status == 0 && moment(props.row.etd, 'DD/MM/YY') > moment() || (props.row.status == 0 && (props.row.etd == 'null' || !props.row.etd) ? true : false)
                      " class="btn" @click="onHandlerBooking(props)" v-b-tooltip.hover.top="'Booking Note'">
                        <feather-icon icon="CheckCircleIcon" />
                      </b-button>
                      <b-button variant="primary" size="sm" class="btn" v-b-tooltip.hover="'Incurred cost'"
                        v-if="props.row.status_id == 9" @click="
                          () => {
                            showViewAll(
                              'modal-confirm-incurred-cost',
                              props.row
                            );
                            incurredCost = '';
                          }
                        ">
                        <feather-icon icon="UserPlusIcon" />
                      </b-button>
                      <b-button variant="primary" size="sm" class="btn" v-b-tooltip.hover="
                        props.row.status_id == 9
                          ? 'Confirm Payment'
                          : 'Confirm Booking'
                      " v-if="
  props.row.status_id == 5 ||
  (props.row.status_id == 9 &&
    menus.filter((i) => i.active)[0].text == 'Paid')
" @click="showViewAll('modal-confirm-booking', props.row)">
                        <feather-icon :icon="
                          props.row.status_id == 9
                            ? 'DollarSignIcon'
                            : 'CheckSquareIcon'
                        " />
                      </b-button>
                    </span>
                  </span>
                  <span v-else-if="props.column.field === 'status'">
                    {{
                        props.row.status == 0
                          ? "New Booking"
                          : "Booking confirmed"
                    }}
                  </span>

                  <span v-else-if="
                    props.column.field === 'booking_date' ||
                    props.column.field === 'etd' ||
                    props.column.field === 'eta'
                  ">
                    {{
                        props.formattedRow[props.column.field]
                    
                    }}
                  </span>
                  <!-- Column: Common -->
                  <span v-else>
                    {{
                        props.formattedRow[props.column.field] == "null"
                          ? ""
                          : props.formattedRow[props.column.field]
                    }}
                  </span>
                </div>
              </template>

              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t("showing") }} </span>
                    <b-form-select v-model="pageSize" :options="['10', '50', '100']" class="mx-1"
                      @input="(value) => onPerPageChange(value)" />
                    <span class="text-nowrap">
                      {{ $t("entries") }}
                    </span>
                  </div>
                  <div>
                    <b-pagination :value="page" :total-rows="totalRecords" :per-page="pageSize" first-number last-number
                      prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="
                        (value) => {
                          return onPageChange(value);
                        }
                      ">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
      <ul class="menuu" ref="menuRight">
        <li class="li-i" @click="onHandleView">
          <feather-icon icon="EyeIcon" class="mr-50" />
          <span>View</span>
        </li>
        <li class="li-i" @click="onHandleCopy" :class="{ 'disabled': isCopyClickRight }">
          <feather-icon icon="CopyIcon" class="mr-50" />
          <span>Copy</span>
        </li>
        <li class="li-i" @click="onHandleEdit" :class="{ 'disabled': !isEditClickRight }">
          <feather-icon icon="EditIcon" class="mr-50" />
          <span>Edit</span>
        </li>

      </ul>
    </b-card>

    <b-modal id="modal-create-booking-note" title="Create Booking Note" no-close-on-backdrop size="xl" hide-footer>
      <b-card-text>
        <b-tabs>
          <b-tab title="Booking  information">
            <b-card-text>
              <request-booking-note @NewBookingNote="handNewBookingNote" :isEdit="isEdit" :key="renderView"
                :readonly="readonly" @booking="onHandlerBooking({ row: rowTmp })" v-model="currentItem" />
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card-text>
    </b-modal>

    <b-modal id="new-booking-note" @hide="onCancelModal" no-close-on-backdrop title="Additional Information" size="xl">
      <vue-perfect-scrollbar :settings="{
        maxScrollbarLength: 150,
        suppressScroll: true,
      }" style="max-height: 80vh" class="scrollable-container scroll-area">
        <b-tabs>
          <!-- RequestBookingNote -->

          <b-tab :active="activeTab == 0" @click="activeTab = 0" title="Booking information">
            <validation-observer ref="requestSubmit">
              <LCL ref="bookingNoteLCL" :key="renderView" :request="request_quotation" />
            </validation-observer>
          </b-tab>
          <b-tab :active="activeTab == 1" @click="activeTab = 1" title="Pricing">
            <b-card-text>
              <keep-alive>
                <create-quotation v-if="request_quotation" :readonly="false" ref="bookingNoteRef" :serviceType="{
                  service_type: '3',
                  company_id: request_quotation.company_id,
                }" step="booking" />
              </keep-alive>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </vue-perfect-scrollbar>
      <template #modal-footer>
        <b-button variant="secondary" size="sm" class="round" @click="$bvModal.hide('new-booking-note')">
          {{ $t("cancel") }}
        </b-button>
        <b-button variant="primary" size="sm" @click="sendBookingNote" class="round" :disabled="isLoading">
          {{ isLoading ? "Loading..." : "Booking" }} 
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import LCL from "./components/LCL.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { checkDateToFormat } from "@/utils/format"

export default {
  components: {
    RequestBookingNote: () => import("../booking-note/RequestBookingNote.vue"),
    LCL,
    ValidationProvider,
    ValidationObserver,
    CreateQuotation: () => import("@/views/wr1/quotation/CreateQuotation.vue"),
  },
  data() {
    return {
      isEditClickRight: false,
      isCopyClickRight: false,
      isPricing: false,
      activeTab: 0,
      isLoading: false,
      renderView: 0,
      isEdit: false,
      moment,
      request_quotation: null,
      rowTmp: null,
      currentItem: {
        prepaid: true,
        collect: false,
        stack_able: true,
        non_stack_able: false,
        rotatable: false,
        oversize: false,
        overweight: false,
        showAddMore: [
          {
            id: 1,
            hasDelete: false,
            showAddMoreLine: [
              {
                id: 2,
                hasDelete: false,
                gross_weight: null,
                volume: null,
                packages: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
            package_type: null,
            total_packages: 0,
            gross_weight_total: 0,
            volume_total: 0,
          },
        ],
        shipping_line: null,
        company_id: null,
        company_name: null,
        customer_name: null,
        sale_name: null,
        vessel_name: null,
        pol_name: null,
        pod_name: null,
        placeOfDelivery_name: null,
        goods_type_name: null,
        Place_of_stuffing_name: null,
        service_type: "3",
        vessel: null,
        customer_id: null,
        customer_email: null,
        sale_id: null,
        booking_date: moment().format("DD/MM/YY")
        ,
        booking_no: null,
        place_of_stuffing: null,
        contact: "Mr HAI : 0938.108.990",
        closing_time: null,
        cut_si_vgm: null,
        pol_port: null,
        pod_port: null,
        placeOfDelivery: null,
        eta: null,
        etd: null,
        goods_type: null,
        packageNumber: null,
        trong_luong: null,
        so_khoi: null,
        note: `1. Please contact our operation 2 hours before loading cargo to stuffing place.
2. Please bring a booking note, declaration, barcode, vgm.
3. Wooden packages & wooden products must be fumigated at shipper's premise.
4. Shipping mark on the surface of all crate/carton/case is shipper's responsibility to attach.
5. Our services such as warehouse, trucking, trailer, and customs clearance, are always available to provide by our own facility. Please keep in contact for any requirements.
6. The cargo which is classified as dangerous, foodstuff, personal effects, over 580 cm length/pkg, over 500kgs/pkg, or required special treatments which are limited for sea transportation have to be informed to WR1 before booking. 
7. For European trade lane: HS code of cargo required to provide at least two days before ETD.
8. For US/Canada trade lanes: No personal effects are accepted.
9. If the consignee refuses to collect cargo and pay destination charges, all arising expenses and destination charges due to abandoning and/or destroying cargo will be debited to the shipper's account.

In case you and/or your relevant parties fail to declare the mentioned request with WR1, all extra arising charges will be debited to your account.`,
      },
      keyword: "",
      pageSize: 10,
      page: 1,
      columns: [
        {
          label: "Booking No",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "id",
          filterOptions: {
            enabled: false,
            placeholder: "Booking No",
          },
        },
        {
          label: "Status",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "status",
          filterOptions: {
            enabled: false,
            placeholder: "Status",
          },
        },
        {
          label: "Booking Date",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "booking_date",
          filterOptions: {
            enabled: false,
            placeholder: "Booking Date",
          },
        },
        {
          label: "Customer",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "customer_name",
          filterOptions: {
            enabled: false,
            placeholder: "Customer",
          },
        },
        {
          label: "Service",
          thClass: "text-uppercase align-middle ",
          tdClass: "align-middle m-0 p-0",
          field: "service_type",
          filterOptions: {
            enabled: false,
            placeholder: "Service",
          },
        },
        {
          label: "ETD",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "etd",
          filterOptions: {
            enabled: false,
            placeholder: "ETD",
          },
        },
        {
          label: "POL",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "pol",
          filterOptions: {
            enabled: false,
            placeholder: "POL",
          },
        },
        {
          label: "POD",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "pod",
          filterOptions: {
            enabled: false,
            placeholder: "POD",
          },
        },
        {
          label: "Place of Delivery ",
          tdClass: "align-middle m-0 p-0",
          thClass: "text-uppercase align-middle",
          field: "placeOfDeliveryName",
          filterOptions: {
            enabled: false,
            placeholder: "Place of Delivery",
          },
        },
        {
          label: "ETA",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle m-0 p-0",
          field: "eta",
          filterOptions: {
            enabled: false,
            placeholder: "ETA",
          },
        },
        {
          label: "Measurement (cbm)",
          tdClass: "align-middle m-0 p-0",
          thClass: "text-uppercase align-middle",
          field: "so_khoi",
          filterOptions: {
            enabled: false,
            placeholder: "Measurement (cbm)",
          },
        },
        {
          label: "Sales WR1",
          tdClass: "align-middle m-0 p-0",
          thClass: "text-uppercase",
          field: "sale_name",
          filterOptions: {
            enabled: false,
            placeholder: "Sales WR1",
          },
        },
        {
          label: "Action",
          tdClass: "align-middle m-0 p-0",
          thClass: "text-uppercase",
          field: "action",
          filterOptions: {
            enabled: false,
            placeholder: "Action",
          },
        },
      ],
      userData: JSON.parse(localStorage.getItem("userData")),
      readonly: false,
      rowSelectCopy: null,
    };


  },
  watch: {
    keyword(n) {
      this.loadItems();
    },
  },
  created() {
    this.$store.dispatch("masterData/FETCH_ALL");
    this.loadItems();
  },
  mounted() {
    const menu = this.$refs.menuRight;
    window.addEventListener("click", () => (menu.style.visibility = "hidden"));

  },
  computed: {
    totalRecords() {
      return this.$store.state.bkNote.totalRecords;
    },
    items() {
      return this.$store.getters["bkNote/getBookingNotes"];
    },
    exchangeRate: function () {
      return this.$store.getters["masterData/exchangeRate"];
    },
  },
  methods: {
    track () {
      this.$gtag.pageview('MyWr1BookingNote')
    },

    onClickRightOpenMenu(e, row) {
      // console.log(e);
      // console.log(row);

      // TODO
      e.preventDefault();

      this.rowSelectCopy = row

      this.isEditClickRight =
        (this.rowSelectCopy.status == 0 && moment(this.rowSelectCopy.etd, 'DD/MM/YY') > moment()) || (this.rowSelectCopy.status == 0 && (this.rowSelectCopy.etd == 'null' || !this.rowSelectCopy.etd) ? true : false)
      const menu = this.$refs.menuRight,
        menuWidth = menu.offsetWidth,
        menuHeight = menu.offsetHeight,
        card = this.$refs.card;

      let x = e.layerX + 20,
        y = e.layerY + 120,
        winWidth = window.innerWidth,
        winHeight = window.innerHeight;
      //   x = x > winWidth - menuWidth ? winWidth - menuWidth - 5 : x;
      // y = y > winHeight - menuHeight ? winHeight - menuHeight - 5 : y;

      menu.style.left = `${x}px`;
      menu.style.top = `${y}px`;
      menu.style.visibility = "visible";
    },
    newBooking() {
      this.isEdit = false;

      this.readonly = false;
      this.currentItem = {
        stack_able: true,
        non_stack_able: false,
        rotatable: false,
        oversize: false,
        overweight: false, prepaid: true,
        collect: false,
        showAddMore: [
          {
            id: 1,
            hasDelete: false,
            showAddMoreLine: [
              {
                id: 2,
                hasDelete: false,
                gross_weight: null,
                volume: null,
                packages: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
            package_type: null,
            total_packages: 0,
            gross_weight_total: 0,
            volume_total: 0,
          },
        ],
        shipping_line: null,
        company_id: null,
        company_name: null,
        customer_name: null,
        sale_name: null,
        vessel_name: null,
        pol_name: null,
        pod_name: null,
        placeOfDelivery_name: null,
        goods_type_name: null,
        Place_of_stuffing_name: null,
        service_type: "3",
        vessel: null,
        customer_id: null,
        customer_email: null,
        sale_id: null,
        booking_date: moment().format("DD/MM/YY"),
        booking_no: null,
        place_of_stuffing: null,
        contact: "Mr HAI : 0938.108.990",
        closing_time: null,
        cut_si_vgm: null,
        pol_port: null,
        pod_port: null,
        placeOfDelivery: null,
        eta: null,
        etd: null,
        goods_type: null,
        packageNumber: null,
        trong_luong: null,
        so_khoi: null,
        note: `1. Please contact our operation 2 hours before loading cargo to stuffing place.
2. Please bring a booking note, declaration, barcode, vgm.
3. Wooden packages & wooden products must be fumigated at shipper's premise.
4. Shipping mark on the surface of all crate/carton/case is shipper's responsibility to attach.
5. Our services such as warehouse, trucking, trailer, and customs clearance, are always available to provide by our own facility. Please keep in contact for any requirements.
6. The cargo which is classified as dangerous, foodstuff, personal effects, over 580 cm length/pkg, over 500kgs/pkg, or required special treatments which are limited for sea transportation have to be informed to WR1 before booking. 
7. For European trade lane: HS code of cargo required to provide at least two days before ETD.
8. For US/Canada trade lanes: No personal effects are accepted.
9. If the consignee refuses to collect cargo and pay destination charges, all arising expenses and destination charges due to abandoning and/or destroying cargo will be debited to the shipper's account.

In case you and/or your relevant parties fail to declare the mentioned request with WR1, all extra arising charges will be debited to your account.`,
      };
      this.$bvModal.show("modal-create-booking-note");
    },
    async loadItems() {
      this.$loading.show();
      await this.$store.dispatch("bkNote/loadItem", {
        search: {
          keyword: this.keyword,
        },
        page: this.page,
        pageSize: this.pageSize,
      });

      this.$loading.hide();
    },
    onPageChange(params) {
      //   this.$loading.show();
      this.page = params;
      this.loadItems();
    },
    onHandlerBooking({ row }) {
      this.activeTab = 0;
      this.request_quotation = row;
      this.request_quotation.bookingID = row.id;
      this.request_quotation.company_id = row.company_id
      this.renderView++;
      this.$bvModal.show("new-booking-note");
    },
    onPerPageChange(params) {
      //   this.$loading.show();
      this.pageSize = params;
      this.page = 1;
      this.loadItems();
    },
    onRowEditClick({ row }) {
      this.rowTmp = row;
      // console.log(row)
      const parse = JSON.parse(row.booking_note);
      this.currentItem = parse;
      this.currentItem.etd = checkDateToFormat(parse.etd);
      this.currentItem.eta = checkDateToFormat(parse.eta);
      this.currentItem.booking_date = checkDateToFormat(parse.booking_date);
      this.currentItem.id = row.id;
      if (row.status == 1) {
        this.currentItem.note = this.currentItem.note;
      }
      this.isEdit = true;
      this.renderView++;
      this.readonly = false;

      this.$bvModal.show("modal-create-booking-note");
    },
    onRowDoubleClick({ row }) {
      // console.log(row)
      this.rowTmp = row;
      const parse = JSON.parse(row.booking_note)
      this.currentItem = parse;
      this.currentItem.etd = checkDateToFormat(parse.etd);
      this.currentItem.eta = checkDateToFormat(parse.eta);
      this.currentItem.booking_date = checkDateToFormat(parse.booking_date);

      this.currentItem.id = row.id;
      if (row.status == 1) {
        this.currentItem.note = this.currentItem.notes;
      }

      this.renderView++;
      this.readonly = true;
      this.$bvModal.show("modal-create-booking-note");
    },
    handNewBookingNote() {
      this.$loading.show();
      if (!this.isEdit) {
        this.postBookingNote();
      } else {
        this.putBookingNote();
      }
    },
    postBookingNote() {
      useJwt
        .post("bookingNote", { ...this.currentItem, eta: this.currentItem.eta ? this.currentItem.eta : '', etd: this.currentItem.etd ? this.currentItem.etd : '' })
        .then((response) => {
          if (response.data.result == 1) {
            this.$bvModal.hide("modal-create-booking-note");
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "New Booking note success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "New Booking error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    putBookingNote() {
      useJwt
        .put("bookingNote", this.currentItem)
        .then((response) => {
          if (response.data.result == 1) {
            this.$bvModal.hide("modal-create-booking-note");
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "New Booking note success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "New Booking error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    onCancelModal() {
    },
    onHandleView() {
      this.$loading.show();

      this.rowTmp = this.rowSelectCopy;
      const parse = JSON.parse(this.rowSelectCopy.booking_note);
      this.currentItem = parse;
      this.currentItem.id = this.rowSelectCopy.id;

      this.currentItem.etd = checkDateToFormat(parse.etd);
      this.currentItem.eta = checkDateToFormat(parse.eta);
      this.currentItem.booking_date = checkDateToFormat(parse.booking_date);



      if (this.rowSelectCopy.status == 1) {
        this.currentItem.note = this.currentItem.notes;
      }
      this.renderView++;
      this.readonly = true;
      this.$bvModal.show("modal-create-booking-note");

      setTimeout(() => {
        this.$loading.hide();
      }, 200);

    },
    onHandleEdit() {
      this.rowTmp = this.rowSelectCopy;
      const parse = JSON.parse(this.rowSelectCopy.booking_note);
      this.currentItem = parse;

      this.currentItem.etd = checkDateToFormat(parse.etd);
      this.currentItem.eta = checkDateToFormat(parse.eta);
      this.currentItem.booking_date = checkDateToFormat(parse.booking_date);

      this.currentItem.id = this.rowSelectCopy.id;
      if (this.rowSelectCopy.status == 1) {
        this.currentItem.note = this.currentItem.notes;
      }
      this.isEdit = true;
      this.renderView++;
      this.readonly = false;

      this.$bvModal.show("modal-create-booking-note");
    },
    onHandleCopy() {
      // console.log('--- onHandleCopy ---', this.rowSelectCopy);
      this.$loading.show();

      const booking_note = JSON.parse(this.rowSelectCopy.booking_note)

      useJwt
        .put("copyBookingNote", {
          id: this.rowSelectCopy.id,
          ...booking_note

        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("copyScheduleListSuccess"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.loadItems();
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("copyScheduleListError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());

    },
    async sendBookingNote() {
      let route = this.$router;
      var newReq = {};
      newReq.files = [];
      for (
        var i = 0;
        i <
        this.$refs.bookingNoteLCL.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()
          .length;
        i++
      ) {
        var file = JSON.parse(
          this.$refs.bookingNoteLCL.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
            i
          ].xhr.response
        ).result;
        file.size =
          this.$refs.bookingNoteLCL.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
            i
          ].size;
        file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
        file.uuid =
          this.$refs.bookingNoteLCL.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
            i
          ].upload.uuid;
        file.username = this.userData.username;
        file.fullName = this.userData.fullName;
        newReq.files.push(file);
      }

      newReq = { ...newReq, ...this.$refs.bookingNoteLCL.request_quotation };

      var validate = await this.$refs.requestSubmit
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.activeTab = 0;
        return;
      }

      var validatePricing = await this.$refs.bookingNoteRef.$refs.quotationRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validatePricing) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.activeTab = 1;

        return;
      }
      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.$refs.bookingNoteRef.$data.currencies.forEach((e) => {
        t += this.$refs.bookingNoteRef.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.$refs.bookingNoteRef.getTotalGrandTotal(e.id);
          vatUSD += this.$refs.bookingNoteRef.getTotalVAT(e.id);
          totalUSD += this.$refs.bookingNoteRef.getTotal(e.id);
        } else {
          totalVatVnd += this.$refs.bookingNoteRef.getTotalGrandTotal(e.id);
          vatVND += this.$refs.bookingNoteRef.getTotalVAT(e.id);
          totalVND += this.$refs.bookingNoteRef.getTotal(e.id);
        }
      });

      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };

      // if (t == 0 || Number.isNaN(t)) {
      //   this.activeTab = 2;

      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   return;
      // }

      this.$refs.bookingNoteRef.$data.quotation.costs =
        this.$refs.bookingNoteRef.$data.costs;
      this.$refs.bookingNoteRef.$data.quotation.cost_total = cost_total;
      this.$refs.bookingNoteRef.$data.quotation.commission =
        this.$refs.bookingNoteRef.$data.commission;

      if (validate && validatePricing) {
        this.$loading.show();
        useJwt
          .put("confirmBookingNote", {
            ...newReq,
            booking_info: {
              ...this.$refs.bookingNoteRef.$data.quotation,
              createdBy: this.userData.username,
              createDate: moment(new Date()).format("DD/MM/YYYY"),
            },
          })
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.loadItems();

            this.$bvModal.hide("new-booking-note");
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      }
    },
  },
};
</script>

<style>
.menuu {
  width: 200px;
  padding: 10px 12px;
  position: absolute;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
  z-index: 99999;
  background: #fff;
  visibility: hidden;

  border-radius: 10px;
}

.li-i {
  list-style: none;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 4px 0 8px;
  border-radius: 5px;
  cursor: pointer;
  color: #606266;
}

.li-i.disabled {
  color: #AAA !important;
  background: transparent !important;
}

.li-i:not(:last-child) {
  margin-bottom: 2px;
}

.li-i:hover {
  background: #f2f2f2;
}


.share {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.share-menu {
  position: absolute;
  width: 200px;
  right: -200px;
  top: -35px;
  padding: 13px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.08);
  opacity: 0;
  transition: 0.2s ease;
}

.share:hover .share-menu {
  opacity: 1;
}

.setting {
  border-top: 1px solid #ccc;
  padding-top: 2px;
}

.test-container {
  padding: 0.75em 0.75em 0.75em 0.75em;
  box-sizing: border-box;
}

.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 1rem !important;
}
</style>